import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import type from './type.js'
import wrapper from './wrapper.js'

export default contract({
  type: array([
    type
  ]),
  wrapper: array([
    wrapper
  ])
})
